import { filterMenuItemsByReadPermission } from "./platformMenuAccess";

export function isPageSettingsItem(item) {
	return Array.isArray(item?.settingsFor) && item.settingsFor.length > 0;
}

export function withoutPageSettingsItems(items = []) {
	return items.filter((item) => !isPageSettingsItem(item));
}

function isSettingsItemForPath(item, pathname = "/") {
	const normalizedPath = `/${String(pathname || "/")}`.replace(/\/{2,}/g, "/").replace(/\/$/, "") || "/";
	const rootSection = normalizedPath.split("/").filter(Boolean)[0] || "";
	const itemRoute = item?.route ? `/${String(item.route).replace(/^\/+/, "").replace(/\/$/, "")}` : "";

	return item.settingsFor.includes(rootSection) || (
		itemRoute && (normalizedPath === itemRoute || normalizedPath.startsWith(`${itemRoute}/`))
	);
}

/**
 * Resolve settings links for the active page from the same environment- and
 * permission-filtered navigation definitions used by the header and sidebar.
 */
export function getPageSettingsActions({ pathname, platforms = [], user } = {}) {
	const settingsItems = platforms.flatMap((platform) =>
		filterMenuItemsByReadPermission(platform?.menu || [], user)
			.filter(isPageSettingsItem)
			.filter((item) => isSettingsItemForPath(item, pathname))
	);

	return settingsItems.flatMap((item) => item.subMenu || [item]);
}
